import { HealthiestFoodRoot, FoodOption, ButtonBox, FoodBox, Span, Header } from './HealthiestFood.styles'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Stack } from 'components/Stack'
import Trans from 'next-translate/Trans'
import { Button } from 'components/Button'
import Link from 'next/link'
export const HealthiestFood = () => {
  const { t } = useTranslation()

  return (
    <HealthiestFoodRoot>
      <Stack direction="column" alignItems="center">
        <Header align='center' size={{ '@initial': 'h3', '@bp2': 'h1' }}>
          {t('why-we-feed-raw:food-comparison.title')}
        </Header>
        <FoodBox>
          <FoodOption>
            <Text font="label" size="h5">
              {t('why-we-feed-raw:food-comparison.sections.kibble.title')}
            </Text>
            <Text>
              <Trans
                components={{ Span: <Span /> }}
                i18nKey='why-we-feed-raw:food-comparison.sections.kibble.description'
              />
            </Text>
          </FoodOption>
          <FoodOption>
            <Text font="label" size="h5">
              {t('why-we-feed-raw:food-comparison.sections.cooked.title')}
            </Text>
            <Text>
              <Trans
                components={{ Span: <Span/> }}
                i18nKey='why-we-feed-raw:food-comparison.sections.cooked.description'
              />
            </Text>
          </FoodOption>
          <FoodOption>
            <Text font="label" size="h5">
              {t('why-we-feed-raw:food-comparison.sections.raw.title')}
            </Text>
            <Text>
              <Trans
                components={{ Span: <Span /> }}
                i18nKey='why-we-feed-raw:food-comparison.sections.raw.description'
              />
            </Text>
          </FoodOption>
        </FoodBox>
      </Stack>
      <ButtonBox>
        <Link href='/meal-plan' passHref>
          <Button>{t('why-we-feed-raw:cta.button')}</Button>
        </Link>
      </ButtonBox>
    </HealthiestFoodRoot>
  )
}

HealthiestFood.displayName = 'WhyWeFeedRawHealthiestFood'
